<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/chain-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">实体门店面临的烦恼</div>
      </div>
      <img src="@/assets/Mobile/images/solution/chain01.png" alt="">
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">零售电商一体化解决方案</div>
      </div>
      <img src="@/assets/Mobile/images/solution/chain02.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">赋予门店一店三开<br>拓展更多销售渠道</div>
      </div>
      <div class="content">
        <img src="@/assets/Mobile/images/solution/chain03.png" alt="">
        <img src="@/assets/Mobile/images/solution/chain04.png" alt="">
        <img src="@/assets/Mobile/images/solution/chain05.png" alt="">
      </div>
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">聚焦门店经营八大场景赋能</div>
      </div>
      <img src="@/assets/Mobile/images/solution/chain06.png" alt="">
    </div>
    <div class="block05">
      <div class="sk-mobile-title">
        <div class="title">核心功能</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain07.png" alt="">
          店铺管理
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain08.png" alt="">
          商品管理
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain09.png" alt="">
          库存管理
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain10.png" alt="">
          采购管理
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain11.png" alt="">
          交易管理
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain12.png" alt="">
          营销管理
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain13.png" alt="">
          分销管理
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain14.png" alt="">
          用户管理
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain15.png" alt="">
          老板学堂
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain16.png" alt="">
          数据报表
        </div>
      </div>
    </div>
    <div class="block06">
      <div class="sk-mobile-title">
        <div class="title">我们的服务</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain17.png" alt="">
          多场线上线下培训
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain18.png" alt="">
          一对一上门指导
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain19.png" alt="">
          多平台流量支持
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/chain20.png" alt="">
          强大的技术支持
        </div>
      </div>
    </div>
    <Case title="零售电商" />
    <ContactForm info-sources="零售电商" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.Retail,
  components: {
    ContactForm,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  background-color: #FAFAFA;
  img {
    width: 340px;
    margin: 17px 0 31px 0;
  }
}
.block02 {
  img {
    width: 344px;
    margin: 19px 0 14px 0;
  }
}
.block03 {
  background-color: #FAFAFA;
  .content {
    padding: 20px 0 10px 0;
    img {
      width: 340px;
      margin-bottom: 10px;
    }
  }
}
.block04 {
  img {
    width: 344px;
    margin-top: 8px;
  }
}
.block05 {
  background-color: #FAFAFA;
  .content {
    padding: 24px 0 14px 0;
    display: flex;
    width: 375px;
    flex-wrap: wrap;
    justify-content: center;
    .item {
      margin: 7px;
      display: flex;
      flex-direction: column;
      line-height: 24px;
      font-size: 10px;
      font-weight: 500;
      color: #595961;
    }
    img {
      width: 57px;
      height: 63px;
    }
  }
}
.block06 {
  .content {
    padding: 24px 0 14px 0;
    display: flex;
    width: 375px;
    justify-content: space-evenly;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      line-height: 24px;
      font-size: 10px;
      font-weight: 500;
      color: #595961;
    }
    img {
      width: 54px;
    }
  }
}
</style>
